// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

import { isAdmin } from 'services/self'
import { store } from 'services/state.js'

import { observer } from 'mobx-react'

import { Menu } from 'semantic-ui-react'
import Sidebar from 'components/Sidebar/Sidebar'
import SidebarHeader from 'components/Sidebar/SidebarHeader'
import MenuLink from 'components/MenuLink'

export const SideNav = observer(() => isAdmin() && (
  <Sidebar>
    <SidebarHeader>Admin</SidebarHeader>
    {store.userType === 'SUPER_ADMIN' && <MenuLink to='/admin/apis'>APIs</MenuLink>}
    <MenuLink>
      Accounts
      <Menu.Menu>
        <MenuLink to='/admin/accounts'>Users</MenuLink>
        <MenuLink to='/admin/accounts/admins'>Admins</MenuLink>
        <MenuLink to='/admin/accounts/invites'>Invites</MenuLink>
        {store.userType === 'SUPER_ADMIN' && <MenuLink to='/admin/accounts/invitepartner'>Invite Partner</MenuLink>}
        {/* <MenuLink to='/admin/accounts/requests'>Requests</MenuLink> */}
      </Menu.Menu>
    </MenuLink>
  </Sidebar>
))
